import { api } from './api';

export const setLocale = (locale: string) =>
  api.post('/api/v1/locale', {
    locale
  });
